import { CommonModule } from "@angular/common";
import { Component, effect, inject, OnDestroy } from "@angular/core";
import { IonicModule, IonIcon, ModalController } from "@ionic/angular";
import { filter } from "rxjs";
import { v4 as uuidv4 } from "uuid";
import { LiveDataService } from "src/app/edge/live/livedataservice";
import { ChannelAddress, Edge, Service, Websocket } from "src/app/shared/shared";
import { ObjectUtils } from "src/app/shared/utils/object/object-utils";
import { environment } from "src/environments";
import { DataService } from "../../shared/dataservice";
import { StatusSingleComponent } from "../single/status.component";
type Colors = `--ion-color-${"warning" | "success" | "danger"}`;

@Component({
    selector: SystemStatusComponent.SELECTOR,
    templateUrl: "./system-status.component.html",
    standalone: true,
    imports: [
        CommonModule,
        IonicModule,
    ],
    providers: [
        { provide: DataService, useClass: LiveDataService },
    ],
})
export class SystemStatusComponent implements OnDestroy {
    private static readonly SELECTOR = "oe-system-status";
    private static readonly SUM_STATE_CHANNEL = new ChannelAddress("_sum", "State");

    public environment = environment;
    public edge: Edge | null = null;

    protected icon: { color: IonIcon["color"], name: IonIcon["name"], style: Colors } | null = null;

    private subscribed = false;
    private liveDataService = inject(DataService);
    constructor(
        public service: Service,
        public modalCtrl: ModalController,
        private websocket: Websocket,
    ) {
        effect(() => {
            const edge = this.service.currentEdge();
            if (edge == null || this.subscribed) {
                return;
            }

            this.subscribed = true;
            this.edge = edge;

            this.liveDataService.subscribeChannels([
                SystemStatusComponent.SUM_STATE_CHANNEL,
            ], edge, uuidv4());

            edge.currentData.pipe(
                filter(currentData => currentData !== null && !ObjectUtils.isObjectNullOrEmpty(currentData.channel))
            ).subscribe((currentData) => {
                const channelValue: number = currentData.channel[SystemStatusComponent.SUM_STATE_CHANNEL.toString()];
                this.setChannelValueToSumState(channelValue, edge);
            });
        });
    }

    ngOnDestroy() {
        this.edge?.unsubscribeFromChannels(SystemStatusComponent.SELECTOR, this.websocket, [SystemStatusComponent.SUM_STATE_CHANNEL]);
    }

    async presentSingleStatusModal() {
        const modal = await this.modalCtrl.create({
            component: StatusSingleComponent,
        });
        return await modal.present();
    }

    private setChannelValueToSumState(channelValue: number, edge: Edge) {
        switch (channelValue) {
            case 0: {
                this.icon = { color: "success", name: "oe-checkmark", style: "--ion-color-success" };
                break;
            }
            case 1: {
                this.icon = { color: "success", name: edge.roleIsAtLeast("admin") ? "oe-info" : "oe-checkmark", style: "--ion-color-success" };
                break;
            }
            case 2: {
                this.icon = { color: "warning", name: "oe-warning", style: "--ion-color-warning" };
                break;
            }
            case 3: {
                this.icon = { color: "danger", name: "oe-error", style: "--ion-color-danger" };
                break;
            }
            default: {
                this.icon = null;
                break;
            }
        }
    }
}
